import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AddTask from "./pages/AddTask";
import Home from "./pages/Home";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import EditTask from "./pages/EditTask";

function App() {
  return (
    <div className="text-[#111827]">
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/add-task" element={<AddTask />} />
          <Route path="/edit-task/:taskId" element={<EditTask />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
